import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentCalendarMultiple: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M19.994 5.007l.004.121.002.122v11.1A3.65 3.65 0 0116.35 20H5.25a4.35 4.35 0 01-.243-.007A3.246 3.246 0 007.75 21.5h8.6a5.15 5.15 0 005.15-5.15v-8.6c0-1.153-.6-2.166-1.506-2.743zM5.25 2A3.25 3.25 0 002 5.25v10.5A3.25 3.25 0 005.25 19h10.5A3.25 3.25 0 0019 15.75V5.25A3.25 3.25 0 0015.75 2H5.25zM3.5 7.5h14v8.25a1.75 1.75 0 01-1.75 1.75H5.25a1.75 1.75 0 01-1.75-1.75V7.5zm1.75-4h10.5c.966 0 1.75.784 1.75 1.75V6h-14v-.75c0-.966.784-1.75 1.75-1.75z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentCalendarMultiple
